<template>
    <!--输入支付密码-->
    <el-dialog title="请输入会员支付密码" :visible.sync="showPayPassword" width="450px" append-to-body>
        <el-input v-model="pay_password" placeholder="请输入支付密码" type="password" :autofocus="true"
                  ref="passwordInput" @keyup.native="e => {if(e.code==='Enter') successEvent()}"
                  v-focus="true"
        ></el-input>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="successEvent">确 定</el-button>
            </span>
    </el-dialog>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "CashInputPassword",
        model: {
            prop: "state",
            event: "change"
        },
        props: {
            state: {
                type: Boolean,
                default: false,
            }
        },
        data: () => ({
            showPayPassword: false,
            pay_password: ""
        }),
        mounted: function () {
            this.showPayPassword = this.state;
        },
        methods: {
            close: function () {
                this.showPayPassword = false;
            },
            successEvent: function () {
                if(this.pay_password === ""){
                    obj.message.error("请输入密码");
                    return ;
                }

                this.$emit("passwordChange", this.pay_password);
                this.close();
            }
        },
        watch: {
            state: function (newData) {
                this.showPayPassword = newData;
                if(newData) {
                    this.pay_password = "";
                    this.$nextTick(() => {
                        this.$refs["passwordInput"].focus();
                    });
                }
            },
            showPayPassword: function (newData) {
                this.$emit("change", newData);
            }
        }
    }
</script>

<style scoped>

</style>
